<template>
  <div class="dash-root">
    <vue-element-loading :active="appLoading" spinner="bar-fade-scale" color="#3ea56e" size="128" is-full-screen />
    <v-snackbar v-model="showsnackbar" color="#3ea56e" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right><v-btn small :ripple="false" text @click="showsnackbar = false"><v-icon style="color: white">mdi-close</v-icon></v-btn></v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center><v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center><ServerError /></v-flex></v-layout>

    <div v-if="!ServerError">
      <div class="dash-page-header">
        <div><p class="dash-page-header__eyebrow">Promotions</p><h1 class="dash-page-header__title">Pending Promo Codes</h1></div>
      </div>

      <div class="promo-grid" v-if="coupon.length > 0">
        <v-row>
          <v-col v-for="(item, i) in coupon" :key="i" cols="12" sm="6" md="4" lg="3">
            <v-card class="modern-promo-card">
              <div class="promo-card-header">
                <div class="promo-badge">{{ item.discountPercentage }}% OFF</div>
              </div>
              <v-card-text class="promo-card-content">
                <h3 class="promo-product-name">{{ item.description }}</h3>
                <p class="promo-desc" style="visibility: hidden; margin-bottom: 0;">Spacer</p>
                
                <div class="promo-code-box">
                  <span class="promo-code-text">{{ item.promoCode }}</span>
                </div>
                
                <div class="promo-dates">
                  <div class="date-item">
                    <span class="date-label">From</span>
                    <span class="date-value">{{ item.validFromDate ? item.validFromDate.slice(0, 10) : '' }}</span>
                  </div>
                  <div class="date-divider"></div>
                  <div class="date-item">
                    <span class="date-label">To</span>
                    <span class="date-value">{{ item.validToDate ? item.validToDate.slice(0, 10) : '' }}</span>
                  </div>
                </div>
              </v-card-text>
              
              <v-card-actions class="promo-actions" style="flex-wrap: wrap;">
                <v-dialog v-model="item.dialogapprove" max-width="400px" content-class="modern-dialog" :key="'approve-'+i">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="action-btn-approve flex-grow-1" v-bind="attrs" v-on="on" depressed small>
                      <v-icon left size="16">mdi-check-circle-outline</v-icon> Approve
                    </v-btn>
                  </template>
                  <v-card class="dialog-card">
                    <div class="dialog-icon success"><v-icon color="#4f46e5" size="32">mdi-check-circle-outline</v-icon></div>
                    <h3 class="dialog-title">Approve Promo Code?</h3>
                    <p class="dialog-subtitle">Are you sure you want to approve this promo code?</p>
                    <div class="dialog-actions">
                      <v-btn class="btn-cancel" @click="item.dialogapprove = false" depressed>Cancel</v-btn>
                      <v-btn class="btn-approve-confirm" @click="approvePromocode(item)" depressed>Approve</v-btn>
                    </div>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="item.dialogReject" max-width="400px" content-class="modern-dialog" :key="'reject-'+i">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="action-btn-reject flex-grow-1" v-bind="attrs" v-on="on" depressed small>
                      <v-icon left size="16">mdi-close-circle-outline</v-icon> Reject
                    </v-btn>
                  </template>
                  <v-card class="dialog-card">
                    <div class="dialog-icon warning"><v-icon color="#d97706" size="32">mdi-alert-circle-outline</v-icon></div>
                    <h3 class="dialog-title">Reject Promo Code?</h3>
                    <p class="dialog-subtitle">Are you sure you want to reject this promo code?</p>
                    <v-text-field outlined v-model="reason" label="Reason" dense class="mb-4"></v-text-field>
                    <div class="dialog-actions">
                      <v-btn class="btn-cancel" @click="item.dialogReject = false" depressed>Cancel</v-btn>
                      <v-btn class="btn-confirm" @click="rejectProduct(item)" depressed>Reject</v-btn>
                    </div>
                  </v-card>
                </v-dialog>

                <div style="flex-basis: 100%; height: 8px;"></div>
                
                <v-btn class="action-btn-edit flex-grow-1" @click="editSlider(item)" depressed small>
                  <v-icon left size="16">mdi-pencil</v-icon> Edit
                </v-btn>
                
                <v-dialog v-model="item.delete" max-width="400px" content-class="modern-dialog">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="action-btn-delete px-3" v-on="on" v-bind="attrs" depressed small>
                      <v-icon size="18">mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="dialog-card">
                    <div class="dialog-icon warning"><v-icon color="#ff4757" size="32">mdi-alert-circle-outline</v-icon></div>
                    <h3 class="dialog-title">Delete Promo Code?</h3>
                    <p class="dialog-subtitle">Are you sure you want to delete this promo code?</p>
                    <div class="dialog-actions">
                      <v-btn class="btn-cancel" @click="item.delete = false" depressed>Cancel</v-btn>
                      <v-btn class="btn-confirm" @click="deleteItem(item)" depressed>Delete</v-btn>
                    </div>
                  </v-card>
                </v-dialog>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-else class="empty-state">
        <v-icon size="64" color="#cbd5e1">mdi-ticket-percent-outline</v-icon>
        <h3 class="empty-state-title">No Pending Promo Codes</h3>
        <p class="empty-state-desc">There are currently no promo codes waiting for approval.</p>
      </div>

      <v-dialog v-model="editdialog" max-width="600px" content-class="modern-dialog">
        <v-card class="form-dialog-card">
          <div class="form-dialog-header"><h3 class="form-dialog-title">Edit Promo Code</h3></div>
          <v-card-text class="pt-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="editingitem.description" label="Title/Description" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="editingitem.validFromDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="editingitem.validFromDate" label="Valid From" outlined dense readonly v-bind="attrs" v-on="on" append-icon="mdi-calendar"></v-text-field>
                    </template>
                    <v-date-picker v-model="editingitem.validFromDate" no-title scrollable color="#3ea56e">
                      <v-spacer></v-spacer>
                      <v-btn text color="#475569" @click="menu = false">Cancel</v-btn>
                      <v-btn text color="#3ea56e" @click="$refs.menu.save(editingitem.validFromDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="editingitem.validToDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="editingitem.validToDate" label="Valid To" outlined dense readonly v-bind="attrs" v-on="on" append-icon="mdi-calendar"></v-text-field>
                    </template>
                    <v-date-picker v-model="editingitem.validToDate" no-title scrollable color="#3ea56e">
                      <v-spacer></v-spacer>
                      <v-btn text color="#475569" @click="menu1 = false">Cancel</v-btn>
                      <v-btn text color="#3ea56e" @click="$refs.menu1.save(editingitem.validToDate)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="editingitem.promoCode" label="Promo Code" :rules="Rules" required outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="editingitem.discountPercentage" label="Discount Percentage" :rules="Rules" required outlined dense append-icon="mdi-percent"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-6 pb-6">
            <v-spacer></v-spacer>
            <v-btn class="btn-cancel" @click="editdialog = false" depressed>Cancel</v-btn>
            <v-btn class="btn-save" @click="edit()" depressed>Save Changes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// import { VueEditor } from "vue2-editor";
export default {
  components: {
    // VueEditor,,
  },
  props: ["Name"],
  data() {
    return {
      checkbox: true,
      ServerError: false,
      file: null,
      showsnackbar: false,
      msg: null,
      pages: 0,
      code: null,
      widthOfCard: "250px",
      addslider: false,
      appLoading: false,
      currentPage: 1,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      dialog: false,
      editdialog: false,
      reason: "",
      imgId: "",
      editingitem: [],
      menu1: false,
      menu: false,
      coupon: [],
      couponData: {
        discountPercentage: null,
        promoCode: null,
        description: "",
        validFromDate: new Date().toISOString().substr(0, 10),
        validToDate: new Date().toISOString().substr(0, 10),
      },
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 15) || "Name must be less than 15 characters",
      ],
      Rules: [(value) => !!value || "Required."],
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "sliderImage") {
        this.sliderImage = window_data.selectedFiles;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/product/promocode/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          status: "Pending",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.coupon = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    deleteItem(id) {
      var data = {};
      data["id"] = id._id;
      axios({
        url: "/product/promocode/delete",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.dialogDelete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    dialogclose() {
      this.link = null;
      this.dialog = false;
    },
    editSlider(item) {
      this.editingitem = item;
      this.editdialog = true;
      this.editingitem.validFromDate = this.editingitem.validFromDate.slice(
        0,
        10
      );
      this.editingitem.validToDate = this.editingitem.validToDate.slice(0, 10);
    },
    edit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/edit/promocode",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          description: this.editingitem.description,
          id: this.editingitem._id,
          promoCode: this.editingitem.promoCode,
          validFromDate: this.editingitem.validFromDate,
          validToDate: this.editingitem.validToDate,
          discountPercentage: this.editingitem.discountPercentage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.getData();
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            this.editdialog = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    approvePromocode(item) {
      axios({
        method: "POST",
        url: "/product/promocode/approve",
        data: {
          id: item._id,
          approve: true,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.ServerError = true;
          console.log(e);
        });
    },
    rejectProduct(item) {
      axios({
        method: "POST",
        url: "/product/promocode/approve",
        data: {
          id: item._id,
          approve: false,
          reason: this.reason,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.dialog = false;
            this.appLoading = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.ServerError = true;
          console.log(e);
        });
    },
  },
};
</script>
<style scoped>
.dash-root { font-family: poppinsmedium, Roboto, sans-serif; padding: 12px 12px; }
.dash-page-header { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 24px; flex-wrap: wrap; gap: 16px; }
.dash-page-header__eyebrow { font-size: 13px; color: #8a93a4; margin: 0 0 4px; font-family: poppinsmedium, sans-serif; text-transform: uppercase; letter-spacing: 0.5px; }
.dash-page-header__title { font-size: 22px; font-weight: 700; color: #1a202c; margin: 0; font-family: poppinsbold, sans-serif; line-height: 1.2; }

.modern-promo-card { background: #ffffff; border: 1px solid #eaedf0; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02) !important; transition: all 0.3s ease; display: flex; flex-direction: column; height: 100%; }
.modern-promo-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px rgba(0, 0, 0, 0.06) !important; border-color: #cbd5e1; }
.promo-card-header { padding: 16px 20px 0; display: flex; justify-content: flex-end; }
.promo-badge { background: #e0f2fe; color: #0284c7; font-size: 12px; font-weight: 700; padding: 4px 12px; border-radius: 20px; font-family: poppinssemibold, sans-serif; display: inline-block; }
.promo-card-content { padding: 12px 20px 20px; flex-grow: 1; display: flex; flex-direction: column; }
.promo-product-name { font-size: 16px; font-weight: 600; color: #1a202c; margin: 0 0 4px; font-family: poppinssemibold, sans-serif; line-height: 1.4; }
.promo-desc { font-size: 13px; color: #64748b; margin: 0 0 16px; line-height: 1.5; flex-grow: 1; }
.promo-code-box { background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 8px; padding: 10px; text-align: center; margin-bottom: 16px; }
.promo-code-text { font-family: 'Courier New', Courier, monospace; font-size: 16px; font-weight: 700; color: #0f172a; letter-spacing: 1px; }
.promo-dates { display: flex; align-items: center; justify-content: space-between; background: #f1f5f9; border-radius: 8px; padding: 10px 12px; }
.date-item { display: flex; flex-direction: column; }
.date-label { font-size: 11px; color: #94a3b8; text-transform: uppercase; font-family: poppinssemibold, sans-serif; margin-bottom: 2px; }
.date-value { font-size: 12px; color: #334155; font-weight: 500; }
.date-divider { width: 1px; height: 24px; background: #cbd5e1; margin: 0 12px; }
.promo-actions { padding: 16px 20px; border-top: 1px solid #f1f5f9; display: flex; gap: 8px; background: #faf8f8; }

.action-btn-delete { background: #fff5f5 !important; border: 1px solid #ffe4e6 !important; border-radius: 8px; color: #ff4757 !important; text-transform: none; font-weight: 600; box-shadow: none !important; }
.action-btn-delete:hover { background: #ffe4e6 !important; }
.action-btn-edit { background: #f0fdf4 !important; border: 1px solid #dcfce7 !important; border-radius: 8px; color: #3ea56e !important; text-transform: none; font-weight: 600; box-shadow: none !important; }
.action-btn-edit:hover { background: #dcfce7 !important; }
.action-btn-approve { background: #e0e7ff !important; border: 1px solid #c7d2fe !important; border-radius: 8px; color: #4f46e5 !important; text-transform: none; font-weight: 600; box-shadow: none !important; }
.action-btn-approve:hover { background: #c7d2fe !important; }
.action-btn-reject { background: #fffbeb !important; border: 1px solid #fef3c7 !important; border-radius: 8px; color: #d97706 !important; text-transform: none; font-weight: 600; box-shadow: none !important; }
.action-btn-reject:hover { background: #fef3c7 !important; }

::v-deep .modern-dialog { border-radius: 16px; }
.dialog-card { padding: 24px; text-align: center; border-radius: 16px; }
.dialog-icon { width: 56px; height: 56px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; }
.dialog-icon.warning { background: #fff5f5; }
.dialog-icon.success { background: #f0fdf4; }
.dialog-title { font-size: 18px; font-weight: 600; color: #1a202c; margin: 0 0 8px; font-family: poppinssemibold, sans-serif; }
.dialog-subtitle { font-size: 13px; color: #8a93a4; margin: 0 0 24px; }
.dialog-actions { display: flex; gap: 12px; justify-content: center; }
.btn-cancel { flex: 1; background: #f1f5f9 !important; color: #475569 !important; border-radius: 8px; text-transform: none; font-weight: 600; box-shadow: none !important; }
.btn-confirm { flex: 1; background: #ff4757 !important; color: #ffffff !important; border-radius: 8px; text-transform: none; font-weight: 600; box-shadow: 0 4px 12px rgba(255, 71, 87, 0.2) !important; }
.btn-save { flex: 1; background: #3ea56e !important; color: #ffffff !important; border-radius: 8px; text-transform: none; font-weight: 600; box-shadow: 0 4px 12px rgba(62, 165, 110, 0.2) !important; }
.btn-approve-confirm { flex: 1; background: #4f46e5 !important; color: #ffffff !important; border-radius: 8px; text-transform: none; font-weight: 600; box-shadow: 0 4px 12px rgba(79, 70, 229, 0.2) !important; }

.form-dialog-card { border-radius: 16px; }
.form-dialog-header { padding: 20px 24px 0; }
.form-dialog-title { font-size: 20px; font-weight: 600; color: #1a202c; font-family: poppinssemibold, sans-serif; }

.empty-state { text-align: center; padding: 64px 20px; background: #ffffff; border-radius: 16px; border: 1px dashed #cbd5e1; }
.empty-state-title { font-size: 18px; font-weight: 600; color: #334155; margin: 16px 0 8px; font-family: poppinssemibold, sans-serif; }
.empty-state-desc { font-size: 14px; color: #94a3b8; margin: 0; }
</style>
